export const shadows = {
  xs: '0 1px 2px rgba(27, 24, 21, 0.04)',
  sm: '0 1px 3px rgba(27, 24, 21, 0.06), 0 1px 2px rgba(27, 24, 21, 0.04)',
  md: '0 4px 12px rgba(27, 24, 21, 0.08)',
  lg: '0 12px 28px rgba(27, 24, 21, 0.12)',
}
